<script setup>
import apiDriveSmartliste from "@/services/http/api-drive/client/smartliste";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";

definePageMeta({
  middleware: "authenticated"
});

const { trackPage } = useTrackingPage();
onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});
const { id: magasinId } = storeToRefs(useMagasinStore());
const { layout } = storeToRefs(useContextStore());
const { throwIfAxiosError } = useAxiosHelper();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/mon-compte/mes-produits-habituels/${layout.value}.vue`
    ]
  );
});
const {
  data: smartliste,
  pending,
  error,
  refresh
} = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveSmartliste).smartliste(magasinId.value)
);
throwIfAxiosError(error);
</script>

<template>
  <div>
    <component
      :is="component"
      :smartliste="smartliste"
      :page-is-loading="pending"
      @reload="refresh()"
    />
  </div>
</template>
